import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomTranslateLoader {

  constructor(
    private http: HttpClient
  ) { }

  public getTranslation(lang: string): Observable<any> {
    const apiAddress = `${environment.i18n}${lang}.json`;
    return this.http.get(apiAddress)
      .pipe(
        catchError(this.errortraslation.bind(this, lang))
      );
  }

  private errortraslation = (lang: string) => this.http.get(`/assets/i18n/${lang}.json`);
}
